import EVENT from '../enums/event.js';
import KEY from '../enums/key.js';
import STATE from '../enums/state.js';
import TabTrapper from '../utils/accessibility.tab-trapper.js';
import dispatchEvent from '../utils/dispatch-event.js';

const selectors = {
  cancelButton: '.confirm__cancel',
  confirmButton: '.confirm__confirm',
};

class Confirm {
  /**
   *
   * @param {Element} element
   * @param {string} name
   */
  constructor(element, name) {
    this.$confirm = element;

    if (!this.$confirm) return;

    this.$cancelButton = this.$confirm.querySelector(selectors.cancelButton);
    this.$confirmButton = this.$confirm.querySelector(selectors.confirmButton);

    this.name = name;

    this.registerEventListeners();
    this.hide();
  }

  /**
   * @returns {'closed'|'open'}
   */
  get state() {
    return this.$confirm.dataset.state;
  }

  set state(state) {
    this.$confirm.dataset.state = state;
  }

  registerEventListeners() {
    document.addEventListener(EVENT.CONFIRM.TOGGLE, event => {
      const isNotConfirm =
        event.detail.confirm !== this.name || this.state === STATE.CONFIRM.OPEN;

      if (isNotConfirm) {
        this.closeConfirm();
        return;
      }

      this.openConfirm();
    });

    document.addEventListener(EVENT.OVERLAY.DEACTIVATE, () => {
      this.closeConfirm();
    });

    this.$cancelButton.addEventListener('click', () => {
      dispatchEvent(EVENT.CONFIRM.CANCELLED, document, {
        detail: this,
      });
      this.closeConfirm();
    });

    this.$confirmButton.addEventListener('click', () => {
      dispatchEvent(EVENT.CONFIRM.CONFIRMED, document, {
        detail: this,
      });
      this.closeConfirm();
    });
  }

  openConfirm() {
    this.show();
    this.state = STATE.CONFIRM.OPEN;

    dispatchEvent(EVENT.OVERLAY.ACTIVATE, this.$confirm);
    dispatchEvent(EVENT.CONFIRM.OPENED, document, {
      detail: this,
    });

    // Controlling focus
    this.focusElement = document.activeElement;

    this.tabTrapper = new TabTrapper(this.$confirm);

    document.addEventListener('keydown', event => {
      if (event.key === KEY.ESCAPE) {
        this.closeConfirm();
      }
    });
  }

  closeConfirm() {
    if (this.state === STATE.CONFIRM.CLOSED) return;

    this.state = STATE.CONFIRM.CLOSED;
    this.hide();

    dispatchEvent(EVENT.OVERLAY.DEACTIVATE, this.$confirm);

    // Controlling focus
    if (this.focusElement) {
      this.focusElement.focus();
    }

    if (this.tabTrapper) {
      this.tabTrapper.close();
    }

    document.removeEventListener('keydown', event => {
      if (event.key === KEY.ESCAPE) {
        this.closeConfirm();
      }
    });
  }

  hide() {
    setTimeout(() => {
      this.$confirm.classList.add('hidden');
    }, 200);
  }

  show() {
    this.$confirm.classList.remove('hidden');
  }
}

export default Confirm;
